import { RudderAnalytics } from '@rudderstack/analytics-js';

type AnalyticsPerson = {
  userId: string;
  nickname?: string;
  /** 达人 / 发单者等，勿传手机号 */
  userType?: string;
};

/** 与 RudderStack `ApiObject` 对齐，避免 `unknown` 导致 vue-tsc 过载匹配失败 */
type AnalyticsPrimitive = string | number | boolean | Date;
type AnalyticsProperties = {
  [key: string]: AnalyticsPrimitive | AnalyticsPrimitive[] | AnalyticsProperties | null;
};

const APP = 'h5';

let rudder: RudderAnalytics | null = null;

function trackWriteKey(): string {
  return import.meta.env.VITE_TRACK_WRITE_KEY?.trim() || '';
}

function dataPlaneUrl(): string {
  return (import.meta.env.VITE_TRACK_DATA_PLANE_URL || '').trim().replace(/\/+$/, '');
}

function isEnabled(): boolean {
  return Boolean(trackWriteKey() && dataPlaneUrl());
}

function superProperties(): AnalyticsProperties {
  return {
    app: APP,
    env: import.meta.env.VITE_APP_ENV || 'development',
    app_version: import.meta.env.VITE_APP_VERSION || '',
  };
}

/** 初始化埋点；未配置 Key 时为 no-op */
export function initAnalytics(): void {
  if (!isEnabled()) {
    if (import.meta.env.DEV) {
      console.info('[analytics] disabled: missing VITE_TRACK_WRITE_KEY');
    }
    return;
  }

  rudder = new RudderAnalytics();
  rudder.load(trackWriteKey(), dataPlaneUrl(), {
    onLoaded: () => {
      rudder?.page('', '', superProperties());
    },
  });
}

export function trackPageView(name?: string, properties?: AnalyticsProperties): void {
  if (!isEnabled() || !rudder) return;
  rudder.page('', name || '', { ...superProperties(), ...properties });
}

/** 登录 / 恢复会话后绑定用户；勿传手机号等敏感字段。不在此处打 login_success。 */
export function identifyUser(person: AnalyticsPerson): void {
  if (!isEnabled() || !person.userId || !rudder) return;

  rudder.identify(person.userId, {
    user_type: 'portal',
    portal_user_type: person.userType || '',
    nickname: person.nickname || '',
  });
}

/** 登出重置匿名身份，避免串用户 */
export function resetAnalytics(): void {
  if (!isEnabled()) return;
  rudder?.reset();
}

/** 业务自定义事件 */
export function captureEvent(eventName: string, properties?: AnalyticsProperties): void {
  if (!isEnabled() || !rudder) return;
  rudder.track(eventName, { ...superProperties(), ...properties });
}
